// components/chat/chat-input/LexicalPlaceholder.tsx
interface LexicalPlaceholderProps {
  text?: string;
}

export const LexicalPlaceholder = ({ text = "Ask Shattara anything to learn" }: LexicalPlaceholderProps) => {
  return (
    <div className="pointer-events-none absolute left-1.5 top-0 text-primary/50 text-base">
      {text}
    </div>
  );
};
